import { Typography } from '@bgzt/ui';

import { RankedKeyword, RankedKeywordShiftEnum } from '~/apis/search';
import IcChangeUp from '~/public/assets/icons/ic_change_up.svg';
import IcChangeDown from '~/public/assets/icons/ic_change_down.svg';
import IcNewBadge from '~/public/assets/icons/ic_ranked_keyword_new_badge.svg';

import clsx from 'clsx';
import styles from './RankedKeywordItem.module.css';
import globalStyles from '~/styles/utils.module.css';

type Props = {
  rankedKeyword?: RankedKeyword;
  onClick?: () => void;
};

export const RankedKeywordItem = ({ rankedKeyword, onClick }: Props) => {
  if (!rankedKeyword) return null;

  const renderShift = (shift?: RankedKeywordShiftEnum) => {
    switch (shift) {
      case 'UP':
      case 'NEW':
        return <IcChangeUp />;
      case 'DOWN':
        return <IcChangeDown />;
      case 'NONE':
        return <span className={styles.changeNone} />;
      default:
        return null;
    }
  };

  return (
    <li className={styles.item} onClick={onClick}>
      <Typography variant="L9" color="gray-900" className={styles.order}>
        {rankedKeyword.ranking}
      </Typography>

      <Typography
        variant="L8"
        color="gray-900"
        className={clsx([styles.keyword, globalStyles.singleLineEllipticalText])}
      >
        {rankedKeyword.keyword}

        {rankedKeyword.shift === 'NEW' && <IcNewBadge className={styles.newBadge} />}
      </Typography>

      <span className={styles.change}>{renderShift(rankedKeyword.shift)}</span>
    </li>
  );
};
